import {Row} from 'react-bootstrap';
import Styles from './footer.module.scss';
import {useNavigate} from 'react-router-dom';
import logo from '../../assets/logo.webp';
import facebook from '../../assets/facebook.webp';
import instagram from '../../assets/instagram.webp';


const Footer = () => {
	const navigate = useNavigate();
	const navigateToHome = () => {
		navigate('/');
	}
	const navigateToDashboard = () => {
		navigate('/dashboard');
	}
	const navigateToHealth = () => {
		navigate('/health');
	}
	const navigateToAbout = () => {
		navigate('/about');
	}
	const navigateToContactUs = () => {
		navigate('/contact');
	}
	return (
		<div className={Styles.footer}>
			<div className={Styles.footerContainer}>
				<Row className={Styles.mainFooter}>
					<div className={Styles.footerTextLeft}>
						<h1>AIR-AI: Using Artificial Intelligence to Monitor Air Quality</h1>
						<p>Air-AI ensures the quality of the air you breathe by employing advanced artificial intelligence. Our system intelligently monitors and analyzes air quality data, 
							providing accurate and real-time information. 
						</p>
					</div>
					<div className={Styles.links}>
					<div>
						<h1>LINKS</h1>
						<ul>
							<li><div className={Styles.link} onClick={navigateToHome}>HOME</div></li>
							<li><div className={Styles.link} onClick={navigateToDashboard}>DASHBOARD</div></li>
							<li><div className={Styles.link} onClick={navigateToHealth}>HEALTH AND PRECAUTIONS</div></li>
							<li><div className={Styles.link} onClick={navigateToAbout}>ABOUT</div></li>
							<li><div className={Styles.link} onClick={navigateToContactUs}>CONTACT US</div></li>	
						</ul>
					</div>
				</div>

					<div className={Styles.footerTextRight}>
						<div className={Styles.logo}>
							<img src={logo} alt="" />
						</div>
						<div className={Styles.icons}>
						<a href="https://www.facebook.com/profile.php?id=61559270604813" target="_blank"><img src={facebook} alt="Facebook" /></a>

							<a href ="https://www.instagram.com/air_ai123?igsh=d3Y2eXMxd3Zkemho" target='_blank'><img src={instagram} alt="Instagram" /></a>
						</div>
					</div>
				</Row>
				<Row className={Styles.bottomRow}>
					<p>AIR - AI developed and maintained by Ayesha, Fatima and Wajeeha</p>
				</Row>
			</div>
			<div className={Styles.backgroundContainer}>
				<div className={Styles.background1}></div>
			</div>
		</div>
	);
};

export { Footer };
